





























































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import CredentialsForm from '@/components/CredentialsForm.vue'
import Input from '@/components/Input.vue'
import BaseButton from '@/components/BaseButton.vue'
import { LoginData } from '@/pages/login/entities/login'
import { loginUser } from "@/api/login"
import GrecaptchaBox from '@/components/GrecaptchaBox.vue';

type Input = Vue & { hasError: boolean, hasFocused: boolean }
const DISABLED_SUBDOMAINS: string[] = ['asknicely']

@Component<Login>({
  components: {GrecaptchaBox, BaseButton, Input, CredentialsForm}
})
export default class Login extends Vue {
  public email = ''
  public password = ''
  public mfa = ''
  public loginData?: LoginData
  public error = ''
  public mfaLogin = false

  public async beforeMount() {
    // todo: add a check to see if the user is logged in via API/cookie/session
    const dataEl = document.getElementById('login-data')
    const dataJson = dataEl && dataEl.getAttribute('data-json')
    const data: LoginData = dataJson && JSON.parse(dataJson)

    this.loginData = data
  }

  public async login() {
    this.error = ''
    let recaptchaResponse = ''

    if (this.loginData !== undefined && this.loginData.hasRecaptcha) {
      const grecaptcha = this.$refs.grecaptcha as GrecaptchaBox
      recaptchaResponse = grecaptcha.getResponse()
      if (recaptchaResponse.length < 1) {
        this.error = 'Please complete reCAPTCHA challenge'
        return
      }
    }

    if (!this.mfaLogin) {
      (this.$refs.email as Input).hasFocused = true;
      (this.$refs.password as Input).hasFocused = true
    }

    if (
      this.password === ''
      || !this.email.match(/.+@.+\..+/)
    ) {
      return
    }

    try {
      const { data } = await loginUser(
        this.email,
        this.password,
        (this.mfaLogin ? this.mfa : undefined),
        (this.loginData !== undefined && this.loginData.hasRecaptcha ? recaptchaResponse : undefined)
      )
      if (data.mfa) {
        this.mfaLogin = true
      } else {
        this.redirectTo(data.redirect)
      }
    } catch (e) {
      this.error = e.response.data.error
    }
  }

  public created() {
      window.addEventListener('keydown', e => {
          const isCommandG = (e.metaKey || e.ctrlKey) && e.key === 'g'
          const subDomain = window.location.host.split('.')[0]
          const notDisabled = DISABLED_SUBDOMAINS.indexOf(subDomain) === -1
          if (
              notDisabled &&
              isCommandG &&
              this.loginData !== undefined &&
              this.loginData.enabledGLogin
          ) {
              e.preventDefault()
              this.redirectTo(this.loginData.asknicelyLoginUrl)
          }
      })
  }

  public redirectTo(link) {
    return location.replace(link);
  }
}
